import { connect } from 'react-redux'
import { gql } from '@apollo/client'
import Home from './Home'
import QueryWrapper from '../../utils/QueryWrapper'
import { PROJECT } from '../../env'
import CONFIG from '../../configurator'
import { DATO_IMAGE, ProjectList } from '../../utils/constants'

let core = ''
let lessons = ''
let lessonsList = ''
const comingSoon = PROJECT === ProjectList.SJ ? 'comingSoon' : ''
const comingSoonLesson = PROJECT === ProjectList.OPLA ? 'comingSoon' : ''

if (CONFIG[PROJECT].gibridNavigation) {
  lessons = `lessons {
        slug
      }`
}

if (CONFIG[PROJECT].lessonsList) {
  lessonsList = `lessons {
        id
        slug
        title
        ${comingSoonLesson}
        description(markdown: true)
        cover {
            responsiveImage(imgixParams: { auto: format, fit: crop, w: "1200" }) {
            ${DATO_IMAGE}
            }
        }
    }`
}

if (!CONFIG[PROJECT].single) {
  core = `core: home(locale: $locale) {
      title
      text(markdown: true)
      image {
        responsiveImage(imgixParams: { auto: format, fit: crop, w: "1200" }) {
            ${DATO_IMAGE}
        }
      }
    }`
}

if (!CONFIG[PROJECT].single) {
  core = `core: home(locale: $locale) {
      title
      text(markdown: true)
      image {
        responsiveImage(imgixParams: { auto: format, fit: crop, w: "1400" }) {
            ${DATO_IMAGE}
        }
      }
    }`
}

const HOME_QUERY = gql`
  query($locale: SiteLocale!, $extensionsLang: SiteLocale!) {
    modules: allModules(locale: $locale, filter: { expansionPacks: { eq: false } }, orderBy: startPosition_ASC) {
      cardDescription
      introduction(markdown: true)
      id
      slug
      kitKind
      title
      coverImage {
        url
        responsiveImage(imgixParams: { auto: format, fit: crop, w: "800" }) {
           ${DATO_IMAGE}
        }
      }
     ${lessons}
     showOnHomePage
    }
    extensions: allModules(locale: $extensionsLang, filter: { expansionPacks: { eq: true } }, orderBy: startPosition_ASC) {
      showOnHomePage
      cardDescription
      introduction(markdown: true)
      id
      slug
      ${comingSoon}
      kitKind
      title
      coverImage {
        url
        responsiveImage(imgixParams: { auto: format, fit: crop, w: "800" }) {
           ${DATO_IMAGE}
        }
      }
      linkLearnMore
      ${lessonsList}
    }
    ${core}
  }
`

function HomeContainer(props) {
  return QueryWrapper(HOME_QUERY, Home, props)
}

const mapStateToProps = (state) => {
  return {
    kitsData: state.root.kits.data,
  }
}

export default connect(mapStateToProps)(HomeContainer)
